import { makeRequest } from 'utils/requestLogger';

export default (subscriptionID, toggleToTrue) =>
  makeRequest('post', `/api/subscriptions/${subscriptionID}/update`, {
    is_pinned: toggleToTrue,
  });



// WEBPACK FOOTER //
// ./src/app/features/dashboard/dashboard.services/pinCourse.js